











































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ComposeEmail from "@/components/Messaging/ComposeEmail.vue";
import ComposeText from "@/components/Messaging/ComposeText.vue";
import { collections } from "@/configs/firebase";

@Component({ components: { ComposeEmail, ComposeText } })
export default class SendTextAndEmail extends Vue {
  @Prop() email!: string;
  @Prop() phoneNumber!: string;
  @Prop() lead!: any;

  selectedTemplate = null;
  templates: any[] = [];

  async mounted() {
    const snapshot = await collections.messageTemplates.get();
    this.templates = snapshot.docs.map(doc => doc.data());
  }
}
